import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type RetailLocationsWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.retailLocations> & {
    retailLocationUdoTemplates: Record<Uuid, {udoTemplateId: Uuid}>;
};

export const retailLocationsWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({}),
    retailLocationUdoTemplates: zod.record(uuidZodValidator, zod.strictObject({udoTemplateId: uuidZodValidator})),
}) satisfies zod.ZodType<RetailLocationsWorkspaceCapabilityUdoBindings>;
